import genericStore from "../generic_store";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "spot_helps",
    object: "spot_help",
    header: [
      { text: "Imagen", value: "picture" },
      { text: "Info", value: "user_info" }, // NUEVA columna combinada
      // { text: "Estadia", value: "rent_order_id" },
      { text: "Opciones de Ayuda", value: "help_option_id" },
      { text: "Comentario", value: "comment" },
      { text: "Acciones", value: "actions", sortable: false }
    ]
  },
  mutations: {
    ...genericStore.mutations
  },
  actions: {
    ...genericStore.actions
  },
  getters: {
    ...genericStore.getters
  }
};
